module.exports = __webpack_public_path__ + "img/1479387244.a44c3190.jpg";